'use client';

import { type ComponentPropsWithRef } from 'react';

import { VisuallyHidden } from '@repo/ui/VisuallyHidden';
import { Chip } from '@repo/ui/Chip';
import type { ChipBaseProps, ChipVariant } from './Chip.tsx';
import { Radio } from '@repo/ui/Radio';

export type RadioChipProps = ChipBaseProps &
  ComponentPropsWithRef<'input'> & {
    id: string;
    name: string;
    value: string;
    variant?: ChipVariant;
  };

export const RadioChip = (props: RadioChipProps) => {
  const {
    ariaDisabled,
    children,
    className,
    disabled,
    id,
    isSelected,
    name,
    value,
    variant = 'default',
    ...attrs
  } = props;

  if (!children) {
    return null;
  }

  return (
    <Chip
      asChild
      ariaDisabled={ariaDisabled}
      className={className}
      disabled={disabled}
      isSelected={isSelected}
      variant={variant}
    >
      <label htmlFor={id}>
        <VisuallyHidden>
          <Radio id={id} name={name} value={value} {...attrs} />
        </VisuallyHidden>
        {children}
      </label>
    </Chip>
  );
};
